(() => {
  const localeRoot = window.Shopify?.routes?.root || window.FoxTheme?.routes?.root_url || '/';
  if (localeRoot === '/') return;

  const localizedRoot = localeRoot.replace(/\/$/, '');
  const storefrontPaths = new Set([
    'account',
    'blogs',
    'cart',
    'collections',
    'pages',
    'policies',
    'products',
    'search',
  ]);

  const localizeLink = (link) => {
    const href = link.getAttribute('href');
    if (!href || !href.startsWith('/') || href.startsWith('//') || link.hasAttribute('hreflang')) return;
    if (href === localizedRoot || href.startsWith(`${localizedRoot}/`)) return;

    const firstPathSegment = href.split(/[/?#]/)[1];
    if (!storefrontPaths.has(firstPathSegment)) return;

    link.setAttribute('href', `${localizedRoot}${href}`);
  };

  const localizeLinks = (root) => {
    if (root instanceof HTMLAnchorElement) localizeLink(root);
    root.querySelectorAll?.('a[href]').forEach(localizeLink);
  };

  localizeLinks(document);

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node instanceof Element) localizeLinks(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
